module.exports = __webpack_public_path__ + "img/fnorig.eadd5b4c.jpg";